import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { CreateTeacherStudioBody } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const createTeacherStudio = createAsyncThunk<string, CreateTeacherStudioBody, { extra: Partial<Dependencies> }>(
  "teacher/studio/create",
  async (body, { extra: { teacherRepository } }) => {
    return teacherRepository!.createStudio(body);
  },
);

export const resetCreateTeacherStudio = createAction("teacher/studio/resetCreate");
